// extracted by mini-css-extract-plugin
export default {"full":"Inscription_full__2xqek","form":"Inscription_form__EBC2X","input":"Inscription_input__Iyhff","help":"Inscription_help__kSdlK","button":"Inscription_button__xo8L7"};